// GiftCertificate/GiftCertificatesPage.tsx

import React, {useEffect, useState} from 'react';
import {useErrorProcessing} from 'Core/components/ErrorProvider';
import {axios, DOMAIN_URL} from 'Auth/axiosConfig';
import CircularProgress from 'Core/components/elements/CircularProgress';

import {FRCT} from 'WideLayout/Layouts';
import GiftCertificateCard from 'GiftCertificate/GiftCertificateCard';
import pprint from 'Utils/pprint';
import {IGiftCertificate} from "Types/commerce/gift_certificate";
import Head from "Core/components/Head";

interface GiftCertificatesPageProps {
    cls?: string;
}

const GiftCertificatesPage: React.FC<GiftCertificatesPageProps> = (
    {
        cls,
    }) => {
    const [giftCertificates, setGiftCertificates] = useState<IGiftCertificate[]>([]);
    const {byResponse} = useErrorProcessing();

    useEffect(() => {
        const fetchGiftCertificates = async () => {
            try {
                const response = await axios.get('/api/v1/gift-certificates/');
                console.log('Gift Certificates');
                pprint(response.data);
                setGiftCertificates(response.data);
            } catch (error) {
                byResponse(error);
            }
        };
        fetchGiftCertificates();
    }, []);

    if (!giftCertificates.length) return <CircularProgress size={'150px'}/>;

    return (
        <><Head
            title={'Сертификаты | Лайф Хелп'}
            description={'Помощь квалифицированных психологов от сервиса Лайф Хелп'}
            robots={'noindex, nofollow'}
            canonicalUrl={`${DOMAIN_URL}/gift-certificates`}/><FRCT cls={cls} maxW={800} mx={'auto'} p={2} wrap g={2}>
            {giftCertificates.map((giftCertificate) => (
                <GiftCertificateCard key={giftCertificate.id} giftCertificate={giftCertificate}/>
            ))}
        </FRCT></>
    );
};

export default GiftCertificatesPage;
